import React from 'react';
import { Fuel } from 'lucide-react';
import { ENERGIES } from '../services/fuel';

const LABELS = { essence: 'Essence', diesel: 'Diesel', electrique: '100 % électrique' };

// Admin product form: energy restriction checkboxes (nothing ticked = every powertrain)
export const FuelRestrictionField = ({ value = [], onChange, testId = 'product-fuel' }) => {
  const toggle = (e) => onChange(value.includes(e) ? value.filter(x => x !== e) : ENERGIES.filter(x => x === e || value.includes(x)));
  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-gray-50" data-testid={testId}>
      <p className="text-sm font-semibold text-gray-800 flex items-center gap-2"><Fuel size={16} className="text-orange-500" /> Restriction d'énergie</p>
      <p className="text-xs text-gray-500 mt-0.5 mb-3">Rien de coché = convient à toutes les motorisations. Sinon la pièce n'est proposée qu'aux véhicules de l'énergie cochée (hybrides et GPL comptent comme leur moteur thermique).</p>
      <div className="flex flex-wrap gap-4">
        {ENERGIES.map(e => (
          <label key={e} className="inline-flex items-center gap-2 text-sm text-gray-800 cursor-pointer">
            <input type="checkbox" data-testid={`${testId}-${e}`} checked={value.includes(e)} onChange={() => toggle(e)} className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
            {LABELS[e]}
          </label>
        ))}
        {value.length > 0 && <button type="button" data-testid={`${testId}-clear`} onClick={() => onChange([])} className="text-xs text-blue-600 hover:underline">Toutes motorisations</button>}
      </div>
    </div>
  );
};

export default FuelRestrictionField;
